<template>
  <div>
    <b-table
      :items="data"
      :fields="fields"
    >
      <template #head(signupDate)>
        <div class="text-nowrap">Signup Date</div>
      </template>
    </b-table>
  </div>
</template>
<script>
import * as firebase from '@/services/firebase/'
import _ from 'lodash'

const fields = ['signupDate', 'name', 'email', 'viewed', 'saved', 'subscribed', 'tier', 'gcash']

export default {
  name: 'userTable',
  data() {
    return {
      data: [],
      fields,
    }
  },
  methods: {
    // get questions and answers from Firestore
    async getUsers() {
      const users = []
      await firebase.firebaseFirestore
        .collection('users')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            users.push(doc.data())
          })
          let helper = users.map(item => {
            return {
              // signupDate: item.signupDate ? this.formatDate(new Date(item.signupDate * 1000)) : this.formatDate(new Date(2021, 3, 23)),
              signupDate: item.signupDate ? (new Date(item.signupDate * 1000)).toISOString() : (new Date(2021, 2, 23, 12)).toISOString(),
              name: item.displayName,
              email: item.email,
              viewed: item.questionsViewed.length,
              saved: item.questionsSaved.length,
              subscribed: item.status.isSubscribed ? 'Yes' : 'No',
              tier: item.status.tier,
              gcash: item.latestGcashPayment ? (new Date(item.latestGcashPayment * 1000)).toISOString().split('T')[0] : '--',
            }
          })
          helper = _.orderBy(helper, ['signupDate'], ['desc'])
          helper.forEach(item => {
            item.signupDate = item.signupDate.split('T')[0]
          })
          this.data = helper
          console.log('Users loaded')
        })
        .catch(err => console.log(err))
    },
    formatDate(date) {
      const d = new Date(date)
      var month = '' + (d.getMonth() + 1)
      var day = '' + d.getDate()
      var year = d.getFullYear()

      if (month.length < 2) { month = '0' + month }
      if (day.length < 2) { day = '0' + day }

      return [year, month, day].join('-')
    },
  },
  mounted() {
    this.getUsers()
      .then(() => {
        console.log('Thumbs up')
      })
      .catch(err => console.log(err))
  },
  computed: {
    emailList() {
      return this.data.map(user => user.email)
    },
  },
}
</script>
